import {cn} from '../../lib/utils';
import {Icon} from '../Icon';

import type {IconName} from '../../icons';
import type {FC} from 'react';

export interface IconLabelBadgeProps {
  icon: IconName;
  label: string;
  className?: string;
}

export const IconLabelBadge: FC<IconLabelBadgeProps> = ({icon, label, className}) => (
  <span
    data-slot="icon-label-badge"
    className={cn(
      'inline-flex items-center gap-1 rounded-lg border border-border bg-background-surface px-2 py-1 text-sm font-medium leading-5 text-fg-secondary shadow-xs',
      className
    )}
  >
    <Icon name={icon} className="size-3 shrink-0 text-fg-blue" />
    <span data-slot="label" className="whitespace-nowrap">
      {label}
    </span>
  </span>
);
